import React from 'react';

import { useIntl } from 'react-intl';
import styled from 'styled-components';

import { CanadaDeliveryLimitState } from 'state/order/hooks/use-canada-order-policy';

const Message = styled.div`
  color: ${Styles.color.black};
  margin-top: 1rem;
  text-align: center;
`;

const Title = styled.p`
  font-weight: ${Styles.fontWeight.heavy};
  margin: 0 0 0.5rem;
`;

const Body = styled.p`
  margin: 0;
`;

interface CanadaCheckoutLimitMessageProps {
  state: CanadaDeliveryLimitState;
}

export const CanadaCheckoutLimitMessage: React.FC<CanadaCheckoutLimitMessageProps> = ({
  state,
}) => {
  const { formatMessage } = useIntl();

  if (state.kind === 'clear') {
    return null;
  }

  const bodyMessageId =
    state.kind === 'minimum' ? 'caDeliveryMinimumMessage' : 'caDeliveryMaximumMessage';

  return (
    <Message role="alert">
      <Title>{formatMessage({ id: 'caCheckoutLimitTitle' })}</Title>
      <Body>{formatMessage({ id: bodyMessageId })}</Body>
    </Message>
  );
};
